firebird.factory('audioFileService', [
    '$window',
    'logService',
    function ($window, logService) {
        const logger = logService.createLoggerWithSource('audioFileService');
        var service = {
            playAudioFile: playAudioFile,
            playEmptyAudio: playEmptyAudio,
            playMeetingLoginChime: playMeetingLoginChime
        };

        return service;

        ////////////////////////

        function playAudioFile(path) {
            try {
                var chime = new $window.Audio(path);
                chime.play();
            } catch (e) {
                logger.log('Unable to play audio file:', e);
            }
        }

        function playEmptyAudio() {
            logger.log('Playing Empty Audio');
            service.playAudioFile('/sounds/5-seconds-of-silence.mp3');
        }

        function playMeetingLoginChime() {
            logger.log('Playing Meeting Login Chime');
            service.playAudioFile('/sounds/Your-meeting-is-starting.wav');
        }
    }
]);
